import { CROP_RATIOS } from "../httpClients/ClippyApi";

export const VALID_FEED_TYPES = new Set([
  "HOME",
  "AWAY",
  "NETWORK",
  "WORLD",
  "THREE_D_VIZ",
  "CMS"
]);

export const FEED_PREFERENCES = [
  { value: "HOME", label: "Home Team" },
  { value: "AWAY", label: "Away Team" },
  { value: "BATTING_TEAM", label: "Batting Team" },
  { value: "PITCHING_TEAM", label: "Pitching Team" },
  { value: "NETWORK", label: "Network" },
  { value: "WORLD", label: "World" },
  { value: "THREE_D_VIZ", label: "3D Viz" },
  { value: "CMS", label: "CMS" }
];

export const QUERY_TYPES = [
  { value: "STRUCTURED", label: "Structured" },
  { value: "FREETEXT", label: "Freetext" }
];

export const VIDEO_FORMAT_OPTIONS = [
  { value: "VIDEO", label: "MP4 Video" },
  { value: "GIF", label: "GIF" },
  { value: "HLS", label: "HLS Video" }
];
export const FEED_EXCLUSION_OPTIONS = [
  { value: "HOME", label: "HOME" },
  { value: "AWAY", label: "AWAY" },
  { value: "NETWORK", label: "NETWORK" },
  { value: "WORLD", label: "WORLD" },
  { value: "THREE_D_VIZ", label: "3D Viz" }
];
export const FREQUENCY_DISPLAY_NAMES = {
  PLAY_END: "After each play",
  INNING_END: "After each inning",
  HALF_INNING_END: "After each half-inning",
  GAME_END: "After each game",
  ALL_GAMES_END: "After all games"
};

export const PLAY_ORDERING_TYPE_DISPLAY_NAMES = {
  NONE: "None",
  CHRONO: "Chronological"
};

export const RULE_FORM_FIELD_LABELS = {
  NAME: "Name",
  ENABLED: "Enabled",
  FREQUENCY: "Frequency",
  CATCHUP_STYLE: "Catchup Style",
  QUERY: "Query",
  FORMAT: "Format",
  FEED_PREFERENCE: "Feed Preference",
  ORDERING_TYPE: "Play Order",
  CROP_RATIO: "Crop Ratio",
  LIMIT_BY: "Limit By",
  LIMIT_COUNT: "Limit Count",
  VIDEO_OPTIONS: "Video Options",
  AUTO_PUBLISH_EXCLUSIONS: "Don't auto-publish if feed is:"
};

export const FIELD_TO_PITS = {
  SEASON: "Season",
  GAME_PK: "GamePk",
  BATTER_PLAYER_ID: "BatterId",
  BATTER_PLAYER_NAME: "BatterName",
  BATTING_TEAM_ID: "BattingTeamId",
  BATTING_TEAM_NAME: "BattingTeamName",
  PITCHER_PLAYER_ID: "PitcherId",
  PITCHER_PLAYER_NAME: "PitcherName",
  PITCHING_TEAM_ID: "PitchingTeamId",
  PITCHING_TEAM_NAME: "PitchingTeamName",
  RUNNER_ON_FIRST_ID: "CurrentRunnerIdFirstBase",
  RUNNER_ON_SECOND_ID: "CurrentRunnerIdSecondBase",
  RUNNER_ON_THIRD_ID: "CurrentRunnerIdThirdBase",
  FIELDER: {
    CatcherName: "CatcherId",
    CenterFielderName: "CenterFielderId",
    LeftFielderName: "LeftFielderId",
    RightFielderName: "RightFielderId",
    FirstBasemanName: "FirstBasemanId",
    SecondBasemanName: "SecondBasenameId",
    ShortstopName: "ShortstopId",
    ThirdBasemanName: "ThirdBasemanId",
    PrimaryFielderPosCode: "PrimaryFielderPosId",
    PrimaryFielderName: "PrimaryFielderPosId"
  }
};

export const CONTENT_EXPERIENCE = {
  MLB: "MLB",
  MILB: "MILB"
};

export const CMS_DESTINATION = {
  MLB: "MLB",
  MILB: "MILB"
};

export const CMS_DESTINATION_LABEL = {
  [CMS_DESTINATION.MLB]: "MLB Forge",
  [CMS_DESTINATION.MILB]: "MiLB Forge"
};

export const MLB_SPORT_ID = 1;
export const TRIPLE_A_SPORT_ID = 11;
export const DOUBLE_A_SPORT_ID = 12;
export const HIGH_A_SPORT_ID = 13;
export const SINGLE_A_SPORT_ID = 14;
export const MINORS_SPORT_ID = 21;

export const CUSTOM_CLIP_TIME_FORMAT = "HH:mm:ss.SSS";

export const DEFAULT_UNSET_WATERMARK = "None";
export const DEFAULT_UNSET_CAPTIONS = "None";
export const DEFAULT_UNSET_CROP_RATIO = "NONE";
export const CAPTIONS_LANGUAGES = [
  { value: "None", label: "None" },
  { value: "english", label: "English" }
];
export const CROP_RATIO_OPTIONS = { ...CROP_RATIOS, None: "NONE" };

export const LIVE_MEDIA_THRESHOLD_SECONDS = 5;

export const MEDIA_SOURCE = {
  DIAMOND: "DIAMOND",
  CONTENT_REGISTRY: "CONTENT_REGISTRY",
  CEREBRO: "CEREBRO"
};

export const DEFAULT_AUDIO_TRACK_NAME = "English";



// WEBPACK FOOTER //
// ./src/utils/constants.js